const makeStagedProgressBarStyling = ({ theme }) => {
  const INACTIVE_GREY = '#CCCCCC'; // Inactive grey color
  const progressBarUnfilledColor =
    theme?.mvf?.palette?.component?.progressBarUnfilledColor;
  const progressBarFilledColor =
    theme?.mvf?.palette?.component?.progressBarFilledColor;

  return {
    progressWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      backgroundColor: progressBarUnfilledColor,
    },
    progressContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      borderRadius: '4px',
      position: 'relative',
      overflow: 'visible',
      padding: `10px ${theme?.mvf?.spacing?.medium} 10px`,
      maxWidth: '750px',
    },

    stageStyle: (isCompleted, isCurrent, hasConnector) => ({
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      flex: hasConnector ? 1 : 'none',
      position: 'relative',
      zIndex: 1,
    }),

    iconWrapper: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      position: 'relative',
      height: '24px',
    },

    stepIcon: (isCompleted, isCurrent) => {
      let backgroundColor;
      if (isCompleted) {
        backgroundColor = progressBarFilledColor;
      } else if (isCurrent) {
        backgroundColor = '#FFFFFF';
      } else {
        backgroundColor = INACTIVE_GREY;
      }

      return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: isCurrent ? '24px' : '20px',
        height: isCurrent ? '24px' : '20px',
        borderRadius: '50%',
        backgroundColor,
        border: isCurrent ? `1px solid ${progressBarFilledColor}` : 'none',
        color: isCurrent ? progressBarFilledColor : '#FFFFFF',
        transition: 'all 0.3s ease',
        transform: isCurrent ? 'scale(1.1)' : 'scale(1)',
        zIndex: 2,
        margin: '0 auto',
      };
    },

    connector: (isActive) => ({
      flex: 1,
      height: 3,
      backgroundColor: isActive ? progressBarFilledColor : INACTIVE_GREY,
      borderRadius: 1,
      position: 'relative',
    }),

    labelsContainer: {
      display: 'flex',
      width: '100%',
      position: 'relative',
      maxWidth: '750px',
      height: '22px',
    },

    stageLabel: (isCurrent, isFirst, isLast, index, totalStages) => {
      if (!isCurrent) {
        return {
          visibility: 'hidden',
          flex: 1,
        };
      }

      // Calculate position for middle stages to align with their icons
      let position = {};

      let offset = '0px';
      if (index === 1) {
        offset = '12px';
      }
      if (index === 2) {
        offset = '-5px';
      }
      if (isFirst) {
        position = {
          textAlign: 'left',
        };
      } else if (isLast) {
        position = {
          textAlign: 'right',
          marginLeft: 'auto', // Push to the right
        };
      } else {
        // For middle stages, we need to position the label to align with its icon
        // Each stage takes up an equal portion of the container width
        const stageWidth = 100 / (totalStages - 1);
        position = {
          position: 'absolute',
          left: `${index * stageWidth}%`,
          transform: `translateX(calc(-50% + ${offset}))`, // Center the label under the icon
          width: 'auto',
        };
      }

      return {
        fontWeight: '600',
        textTransform: 'uppercase',
        color: progressBarFilledColor,
        lineHeight: '16px',
        letterSpacing: '0.48px',
        fontSize: '12px',
        padding: '3px 16px',
        borderRadius: '4px',
        display: 'inline-block',
        ...position,
      };
    },

    // Add currentStageLabel function for tests and mobile view
    currentStageLabel: {
      fontWeight: '600',
      textTransform: 'uppercase',
      textAlign: 'center',
      color: progressBarFilledColor,
      lineHeight: '16px',
      letterSpacing: '0.48px',
      fontSize: '12px',
      padding: '3px 16px',
      backgroundColor: '#F5F5F5',
      borderRadius: '4px',
      display: 'inline-block',
    },
  };
};

export default makeStagedProgressBarStyling;
